module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNjAwIiBoZWlnaHQ9IjEwMDAiIHZpZXdCb3g9IjAgMCAxNiAxMCI+PHBhdGggZmlsbD0iIzAwNmFhNyIgZD0iTTAgMGgxNnYxMEgweiIvPjxwYXRoIGZpbGw9IiNmZWNjMDAiIGQ9Ik01IDBoMnYxMEg1eiIvPjxwYXRoIGZpbGw9IiNmZWNjMDAiIGQ9Ik0wIDRoMTZ2MkgweiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/swe.svg
// module id = Azu0
// module chunks = 0